import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import React, { useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import {
  ControlledMenu,
  MenuItem,
  MenuButton,
  useMenuState,
  useHover,
} from "@szhsin/react-menu";
import { useGeneralContext } from "../../../context/GeneralContext";
import {
  filterAndOrderMenu,
  getSubmenuHeaderCategories,
} from "../../../util/menu";

import * as S from "./style";

const DesktopMenu = () => {
  const ref = useRef(null);
  const [menuState, toggle] = useMenuState({
    transition: true,
  });
  const { anchorProps, hoverProps } = useHover(menuState.state, toggle);

  const { categories, generalContextLoading } = useGeneralContext();

  const orderedMenu = filterAndOrderMenu(categories) || [];
  const orderedSubmenuHeader = getSubmenuHeaderCategories(categories) || [];

  const stateClass = useMemo(() => {
    switch (menuState.state) {
      case "open":
        return "open";
      case "opening":
        return "opening";
      case "closing":
        return "closing";
      default:
        return "closed";
    }
  }, [menuState]);

  const renderMainMenuItems = orderedMenu.map((category) => (
    <Link
      to={`/categoria/${category.id}`}
      title={category.title}
      key={category.id}
    >
      {category.title}
    </Link>
  ));

  const renderSubmenuHeaderItems = () => {
    return (
      <>
        {orderedSubmenuHeader.map((category) => (
          <MenuItem
            href={`/categoria/${category.id}`}
            title={category.title}
            key={category.id}
            id={`btn-submenu_desktop-${category.slug}`}
            name={`btn-submenu_desktop-${category.slug}`}
          >
            {category.title}
          </MenuItem>
        ))}

        <MenuItem
          href="/populares"
          title={"Top 10 / Populares"}
          id={"btn-submenu_desktop-populares"}
          name={"btn-submenu_desktop-populares"}
        >
          Top 10 / Populares
        </MenuItem>
      </>
    );
  };

  const renderAllItems = categories.map((category) => (
    <MenuItem
      href={`/categoria/${category.id}`}
      title={category.title}
      key={category.id}
      className={"react-menu-body-item"}
      id={`btn-submenu_desktop-${category.slug}`}
      name={`btn-submenu_desktop-${category.slug}`}
    >
      {category.title}
    </MenuItem>
  ));

  if (generalContextLoading) {
    return <S.NavBar />;
  }

  return (
    <>
      <S.NavBar>
        <MenuButton
          ref={ref}
          {...anchorProps}
          className={"react-menu-button"}
          id={"btn-menu_desktop-todas_as_categorias"}
          name={"btn-menu_desktop-todas_as_categorias"}
          title={"Todas as categorias"}
        >
          <i className="fas fa-bars"></i> Todas as categorias
        </MenuButton>

        <ControlledMenu
          anchorRef={ref}
          {...hoverProps}
          {...menuState}
          onClose={() => toggle(false)}
          menuClassName={"react-menu-container"}
          position={"initial"}
          overflow={"auto"}
        >
          <S.SubmenuHeader>{renderSubmenuHeaderItems()}</S.SubmenuHeader>
          <S.SubmenuBody takeOverflow>{renderAllItems}</S.SubmenuBody>
        </ControlledMenu>

        <S.MainMenu>
          <span>|</span>

          {renderMainMenuItems}
        </S.MainMenu>
      </S.NavBar>

      <S.Backdrop className={stateClass} />
    </>
  );
};

export default DesktopMenu;
